import React from "react";

import about1 from '../../../assets/website/images/about-main.png';
import about2 from '../../../assets/website/images/about-1.png';
import about3 from '../../../assets/website/images/about-2.png';
import industries1 from '../../../assets/website/images/industries1.jpg';
import industries2 from '../../../assets/website/images/industries2.jpg';
import industries3 from '../../../assets/website/images/industries3.jpg';
import industries4 from '../../../assets/website/images/industries4.jpg';
import { Link } from "react-router-dom";

function WebsiteAboutUs() {

  return (
    <div className="about-page-section">
      <div className="heading-banner-page">
        <div className="container">
          <h1>About Us</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item active" aria-current="page">About Us</li>
            </ol>
          </nav>
        </div>
      </div>
      <div className="innerpage-padding">
        <div className="container">
          <div className="inner-about-page">
            <figure className="mb-0 about-main-banner">
              <img src={about1} alt="about-banner" />
            </figure>
            <div className="about-content">
              <div className="heading-section d-flex flex-column gap-3 text-center">
                <h4>Commitment to Streamline Your Business Operations</h4>
                <p>At Alvyn POS, we are dedicated to simplifying and optimizing the way businesses operate. We understand that in today’s fast-paced world, efficiency is key, and that’s why our POS system is designed to streamline every aspect of your business—from order entry and management to fulfillment and analytics.</p>

                  <p>Our mission is to provide a solution that helps businesses like yours save time, reduce errors, and focus on what truly matters: delivering exceptional products and experiences to your customers. We believe that technology should enhance your operations, not complicate them.</p>

                  <p>With Alvyn POS, you get a reliable, intuitive platform that grows with your business, empowering you to make smarter decisions, stay ahead of trends, and achieve long-term success. Whether you’re running a small café or a large retail chain, we are committed to being your trusted partner in business optimization.</p>
              </div>
            </div>
            <div className="row about-img-text justify-content-between align-items-center">
              <div className="col-md-6">
                <figure className="mb-0">
                  <img src={about2} alt="about-banner" />
                </figure>
              </div>
              <div className="col-md-6">
                <div className="heading-section d-flex flex-column gap-3">
                  <h4>Our Mission</h4>
                  <p>At Alvyn POS, our mission is simple: to empower businesses with innovative, efficient, and scalable technology solutions. We are dedicated to providing businesses—whether small cafés or large retail chains—with a Point-of-Sale system that not only streamlines operations but also enhances customer experiences.

Our goal is to make your day-to-day operations seamless and stress-free, helping you focus on what matters most—growing your business. We believe in delivering reliable, intuitive technology that evolves with your needs and drives long-term success.

We are committed to making your business operations smarter, faster, and more efficient, ensuring you stay ahead in today’s competitive market.</p>
                  {/* <p>Lorem Ipsum is simply dummy text of the printing and  typesetting industry. Lorem Ipsum has been the</p> */}
                </div>
              </div>
            </div>
            <div className="row about-img-text justify-content-between align-items-center">
              <div className="col-md-6">
                <div className="heading-section d-flex flex-column gap-3">
                  <h4>Our Mission</h4>
                  <p>At Alvyn POS, our mission is simple: to empower businesses with innovative, efficient, and scalable technology solutions. We are dedicated to providing businesses—whether small cafés or large retail chains—with a Point-of-Sale system that not only streamlines operations but also enhances customer experiences.

Our goal is to make your day-to-day operations seamless and stress-free, helping you focus on what matters most—growing your business. We believe in delivering reliable, intuitive technology that evolves with your needs and drives long-term success.

We are committed to making your business operations smarter, faster, and more efficient, ensuring you stay ahead in today’s competitive market.</p>
                </div>
              </div>
              <div className="col-md-6">
                <figure className="mb-0">
                  <img src={about3} alt="about-banner" />
                </figure>
              </div>
            </div>
          </div>
        </div>
        <div className="about-3-block section-padding">
          <div className="container">
            <h3>You've done everything to build your business. We help you take the next big step.</h3>
            <div className="about-3-block-content">
              <div className="row m-0">
                <div className="col">
                  <div className="about-3-block-item">
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M36.779 16.9042L23.632 3.75725C21.289 1.41425 17.49 1.41425 15.147 3.75725L3.757 15.1472C2.632 16.2722 2 17.7982 2 19.3902V43.5402C2 46.8542 4.686 49.5402 8 49.5402H27.012" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M41.1851 34.1688C46.0529 34.1688 49.9991 31.5304 49.9991 28.2758C49.9991 25.0212 46.0529 22.3828 41.1851 22.3828C36.3173 22.3828 32.3711 25.0212 32.3711 28.2758C32.3711 31.5304 36.3173 34.1688 41.1851 34.1688Z" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M49.9991 36.1455C49.9991 39.3995 46.0531 42.0385 41.1851 42.0385C36.3171 42.0385 32.3711 39.4005 32.3711 36.1455" stroke="#E42375" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M49.9991 44.0146C49.9991 47.2686 46.0531 49.9076 41.1851 49.9076C36.3171 49.9076 32.3711 47.2696 32.3711 44.0146" stroke="#E42375" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M19.3894 19.4009C20.9021 19.4009 22.1284 18.1746 22.1284 16.6618C22.1284 15.1491 20.9021 13.9229 19.3894 13.9229C17.8767 13.9229 16.6504 15.1491 16.6504 16.6618C16.6504 18.1746 17.8767 19.4009 19.3894 19.4009Z" fill="white" />
                    </svg>
                    <h4>Sell better</h4>
                    <p>You've put in the hard work to establish your business. Now it's time to take it to the next level. With Alvyn POS, we help you streamline your operations, improve customer experiences, and unlock new growth opportunities. Our powerful system is designed to help you sell smarter, faster, and more efficiently. </p>
                  </div>
                </div>
                <div className="col">
                  <div className="about-3-block-item">
                    <svg width="48" height="52" viewBox="0 0 48 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M29.5046 10.8477L16.3066 20.8347" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M15.8984 29.416L29.1074 37.97" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M9.658 32.6324C13.8874 32.6324 17.316 29.2038 17.316 24.9744C17.316 20.745 13.8874 17.3164 9.658 17.3164C5.4286 17.3164 2 20.745 2 24.9744C2 29.2038 5.4286 32.6324 9.658 32.6324Z" stroke="#E42375" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M37.0547 50.0001C41.8883 50.0001 45.8067 46.0817 45.8067 41.2481C45.8067 36.4145 41.8883 32.4961 37.0547 32.4961C32.2211 32.4961 28.3027 36.4145 28.3027 41.2481C28.3027 46.0817 32.2211 50.0001 37.0547 50.0001Z" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M33.7259 12.94C36.7469 12.94 39.1959 10.491 39.1959 7.47C39.1959 4.449 36.7469 2 33.7259 2C30.7049 2 28.2559 4.449 28.2559 7.47C28.2559 10.491 30.7049 12.94 33.7259 12.94Z" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <h4>Manage your entire business</h4>
                    <p>Alvyn POS simplifies your operations, helping you oversee everything from sales and inventory to customer data and reporting—all in one place. Streamline your workflow and make smarter business decisions effortlessly. </p>
                  </div>
                </div>
                <div className="col">
                  <div className="about-3-block-item">
                    <svg width="44" height="52" viewBox="0 0 44 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.4516 19.7568L17.8516 29.7328L22.2586 36.1738L26.0846 29.7328L25.0176 18.8848" stroke="#E42375" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M37.936 49.7989H6C3.791 49.7989 2 48.0079 2 45.7989V22.4199C2 20.2109 3.791 18.4199 6 18.4199H37.936C40.145 18.4199 41.936 20.2109 41.936 22.4199V45.7989C41.936 48.0079 40.145 49.7989 37.936 49.7989Z" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M10.5566 13.41C10.5566 7.134 15.6916 2 21.9666 2C28.2426 2 33.3766 7.135 33.3766 13.41" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <h4>Join the digital revolution</h4>
                    <p>Embrace the future with Alvyn POS. Upgrade your business operations with cutting-edge technology, streamline processes, and stay ahead of the competition in a fast-evolving digital world. </p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <section className="industries-sec">
          <div className="container">
            <div className="heading-section d-flex flex-column gap-3 mb-5 w-50">
              <h4>Multiple Industries We Serve</h4>
              <p>At Alvyn POS, we believe every business deserves a solution tailored to its unique needs. That’s why our powerful, flexible, and scalable Point-of-Sale system is designed to cater to a variety of industries, ensuring seamless operations and growth.</p>
            </div>
            <div className="industries-list">
              <div className="row">
                <div className="col-md-3">
                  <article>
                    <figure>
                      <img src={industries1} alt="Pouring coffee" className="img-fluid" />
                    </figure>
                    <figcaption>
                      <h4>Retail</h4>
                      <p>Simplify checkout processes, manage stock in real time, and gain insights into customer preferences.</p>
                    </figcaption>
                  </article>
                </div>
                <div className="col-md-3">
                  <article>
                    <figure>
                      <img src={industries2} alt="Pouring coffee" className="img-fluid" />
                    </figure>
                    <figcaption>
                      <h4>Food & Beverage</h4>
                      <p>In the fast-paced world of food and beverage, efficiency and customer satisfaction are key.</p>
                    </figcaption>
                  </article>
                </div>
                <div className="col-md-3">
                  <article>
                    <figure>
                      <img src={industries3} alt="Pouring coffee" className="img-fluid" />
                    </figure>
                    <figcaption>
                      <h4>Café</h4>
                      <p>Streamline orders, manage reservations, and track inventory effortlessly to create a delightful dining experience.</p>
                    </figcaption>
                  </article>
                </div>
                <div className="col-md-3">
                  <article>
                    <figure>
                      <img src={industries4} alt="Pouring coffee" className="img-fluid" />
                    </figure>
                    <figcaption>
                      <h4>Supermarkets</h4>
                      <p>Handle high-volume sales with ease, track perishables, and manage vendor relationships efficiently.</p>
                    </figcaption>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default WebsiteAboutUs;